import { getCloudflareRegionForAzure } from '../config/regions';

const isValidRegionKey = (regionKey: string | undefined): boolean => {
  const trimmed = (regionKey ?? '').trim();
  if (!trimmed) {
    return false;
  }
  return getCloudflareRegionForAzure(trimmed) !== undefined;
};

const getApiBase = (): string => {
  const explicit = import.meta.env.VITE_API_BASE_URL as string | undefined;
  if (explicit && explicit.trim().length > 0) {
    return explicit.trim();
  }

  if (typeof window === 'undefined') {
    return '/api';
  }

  const { protocol, hostname, origin } = window.location;
  const host = hostname.toLowerCase();

  if (host === 'sendallfiles.com' || host === 'www.sendallfiles.com') {
    return `${protocol}//api.sendallfiles.com/api`;
  }

  const regionalFrontendMatch = /^([a-z0-9]+)\.sendallfiles\.com$/.exec(host);
  if (regionalFrontendMatch && regionalFrontendMatch[1]) {
    const region = regionalFrontendMatch[1];
    if (isValidRegionKey(region)) {
      return `${protocol}//${region}api.sendallfiles.com/api`;
    }
    return `${protocol}//api.sendallfiles.com/api`;
  }

  return `${origin}/api`;
};

const getApiBaseForRegion = (regionKey: string): string => {
  const trimmed = (regionKey ?? '').trim().toLowerCase();
  if (!trimmed) {
    return getApiBase();
  }

  if (typeof window === 'undefined') {
    return '/api';
  }

  const { protocol, hostname } = window.location;
  const host = hostname.toLowerCase();

  // Only use regional hostnames when running on sendallfiles.com
  if (host.endsWith('sendallfiles.com')) {
    if (isValidRegionKey(trimmed)) {
      return `${protocol}//${trimmed}api.sendallfiles.com/api`;
    }
    return `${protocol}//api.sendallfiles.com/api`;
  }

  return getApiBase();
};

export { getApiBase, getApiBaseForRegion };
